"use strict";

exports.__esModule = true;
exports.SettingsMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _IconMenu = require("../../Core/IconMenu");
var _Auth = require("../../Auth");
var _LegacyContext = require("../LegacyContext");
var _RestAPI = require("../../API/RestAPI");
var _Locale = require("../../Env/Locale");
var _Env = require("../../Env");
var _LogoutMenuItem = require("./LogoutMenuItem");
var _UiPreferencesDialog = require("../../UiPreferences/UiPreferencesDialog");
var _UiPreferencesContext = require("../../UiPreferences/UiPreferencesContext");
var _System = require("../../../System");
var _AnyAccessCheck = require("../../Auth/Access/AnyAccessCheck/AnyAccessCheck");
var _dec, _dec2, _dec3, _dec4, _class, _SettingsMenu;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var configurationApps = [{
  id: "SettingsMenu.AuditLog",
  screenName: "AuditLogList",
  name: "Audit Log",
  accessRight: "VIEW_AUDIT_LOG"
}, {
  id: "SettingsMenu.UserNotifications",
  screenName: "UserNotifications",
  name: "Messages",
  accessRight: "EDIT_MESSAGES"
}];

/**
 * Settings Menu
 */
var SettingsMenu = exports.SettingsMenu = (_dec = _Env.EnvContext.withContext, _dec2 = _LegacyContext.LegacyContext.withContext, _dec3 = _Auth.AuthContext.withContext, _dec4 = _RestAPI.RestAPIContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (0, _reactRouterCompat.withRouter)(_class = (_SettingsMenu = /*#__PURE__*/function (_Component) {
  function SettingsMenu() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isUiPreferencesOpen: false
    };
    return _this;
  }
  _inheritsLoose(SettingsMenu, _Component);
  var _proto = SettingsMenu.prototype;
  _proto.handleClick = function handleClick(location) {
    var history = this.props.history;
    history.push(location);
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      legacy = _this$props.legacy,
      env = _this$props.env,
      plantName = _this$props.plantName,
      auth = _this$props.auth;
    var renderDevicePage = function renderDevicePage() {
      return /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
        permission: "PLANT_TWIN"
      }, function (_ref) {
        var isAllowed = _ref.isAllowed;
        if (isAllowed) {
          return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
            text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "SettingsMenu.PlantTwin",
              defaultMessage: "Plant Twin"
            }),
            onClick: function onClick() {
              return _this2.handleClick("/plant-twin");
            }
          });
        }
        return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "SettingsMenu.Devices",
            defaultMessage: "Devices"
          }),
          onClick: function onClick() {
            return _this2.handleClick("/devices");
          }
        });
      });
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_UiPreferencesContext.UiPreferencesContext.Consumer, null, function (_ref2) {
      var enabled = _ref2.enabled;
      return enabled ? /*#__PURE__*/_react["default"].createElement(_UiPreferencesDialog.UiPreferencesDialog, {
        isOpen: _this2.state.isUiPreferencesOpen,
        onClose: function onClose() {
          return _this2.setState({
            isUiPreferencesOpen: false
          });
        }
      }) : null;
    }), /*#__PURE__*/_react["default"].createElement(_IconMenu.IconMenu, null, /*#__PURE__*/_react["default"].createElement(_core.Menu, null, renderDevicePage(), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Users",
        defaultMessage: "Users"
      }),
      onClick: function onClick() {
        return _this2.handleClick("/users");
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Activities",
        defaultMessage: "Activities"
      }),
      onClick: function onClick() {
        return _this2.handleClick("/plant-state-activities");
      }
    }), legacy.settingsMenu.showCalendar && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Calendar",
        defaultMessage: "Calendar"
      }),
      onClick: function onClick() {
        return _this2.handleClick("/calendar");
      }
    }), legacy.settingsMenu.showRuleConfiguration && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.RuleConfiguration",
        defaultMessage: "Rule Configuration"
      }),
      onClick: function onClick() {
        return _this2.handleClick("/rule-config");
      }
    }), /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
      permission: "VIEW_RULE_CONFIGURATION_UI"
    }, function (_ref3) {
      var isAllowed = _ref3.isAllowed;
      return isAllowed ? /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "SettingsMenu.RuleConfiguration.v2",
          defaultMessage: "Rule Configuration (Experimental)"
        }),
        onClick: function onClick() {
          return _this2.handleClick("/device-rule-config");
        }
      }) : null;
    }), legacy.settingsMenu.showTargets && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Targets",
        defaultMessage: "Targets"
      }),
      onClick: function onClick() {
        return _this2.handleClick("/targets");
      }
    }), /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
      permission: "PLANT_SETTINGS"
    }, function (_ref4) {
      var isAllowed = _ref4.isAllowed;
      return isAllowed ? /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "SettingsMenu.PredefinedComments",
          defaultMessage: "Predefined Comments"
        }),
        onClick: function onClick() {
          return _this2.handleClick("/predefined-comments");
        }
      }) : null;
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Language",
        defaultMessage: "Language"
      })
    }, Object.keys(_Locale.SUPPORTED_LOCALES).map(function (id) {
      var localeDetails = _Locale.SUPPORTED_LOCALES[id];
      return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        style: {
          fontWeight: env.locale.locale === id ? "bold" : ""
        },
        text: localeDetails.longName + " (" + id + ")",
        key: id,
        onClick: function onClick() {
          return env.changeLocale(id);
        }
      });
    })), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), legacy.settingsMenu.showDocs && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Documentation",
        defaultMessage: "Documentation"
      }),
      href: legacy.documentationUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Support",
        defaultMessage: "Contact Support"
      }),
      href: legacy.customSupportUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), legacy.allowedPlants.length > 1 && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Plant",
        defaultMessage: "Plant"
      })
    }, legacy.settingsMenu.showChangePlant && legacy.allowedPlants.map(function (name) {
      return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        style: {
          fontWeight: plantName === name ? "bold" : ""
        },
        text: name,
        key: name,
        onClick: function onClick() {
          return legacy.onChangePlant && legacy.onChangePlant(name);
        }
      });
    })), /*#__PURE__*/_react["default"].createElement(_AnyAccessCheck.AnyAccessCheck, {
      permissions: configurationApps.map(function (app) {
        return app.accessRight;
      }),
      featureFlags: configurationApps.map(function (app) {
        return app.featureFlag;
      })
    }, function (_ref5) {
      var isAllowed = _ref5.isAllowed;
      return isAllowed || legacy.settingsMenu.showSwitchPlant ? /*#__PURE__*/_react["default"].createElement(_core.MenuItem, null, legacy.settingsMenu.showSwitchPlant ? /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "SettingsMenu.switchPlant.title",
          defaultMessage: "Switch Plant"
        }),
        onClick: function onClick() {
          return legacy.onSwitchPlant && legacy.onSwitchPlant();
        }
      }) : null, configurationApps.map(function (app) {
        return /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
          key: app.screenName,
          permission: app.accessRight || undefined,
          featureFlag: app.featureFlag || undefined
        }, function (_ref6) {
          var isAllowed = _ref6.isAllowed;
          return isAllowed ? /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
            onClick: function onClick() {
              return _this2.handleClick((0, _System.getScreenPath)(app.screenName).replace("/:id?", ""));
            },
            text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: app.id,
              defaultMessage: app.name
            })
          }) : null;
        });
      })) : null;
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.Profile",
        defaultMessage: "Profile"
      }),
      onClick: legacy.onProfileClick
    }), /*#__PURE__*/_react["default"].createElement(_UiPreferencesContext.UiPreferencesContext.Consumer, null, function (_ref7) {
      var enabled = _ref7.enabled;
      return enabled ? /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "SettingsMenu.Interface",
          defaultMessage: "Interface"
        }),
        onClick: function onClick() {
          return _this2.setState({
            isUiPreferencesOpen: true
          });
        },
        "data-testid": "SettingsMenu.Item.Interface"
      }) : null;
    }), /*#__PURE__*/_react["default"].createElement(_LogoutMenuItem.LogoutMenuItem, {
      onLogout: auth.logout
    }), legacy.settingsMenu.showMockData && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.UseMockData",
        defaultMessage: "Use Mock Data"
      }),
      onClick: legacy.onToggleMockData,
      intent: _core.Intent.WARNING
    }), legacy.settingsMenu.showRealData && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SettingsMenu.UseRealData",
        defaultMessage: "Use Real Data"
      }),
      onClick: legacy.onToggleMockData,
      intent: _core.Intent.WARNING
    }))));
  };
  return SettingsMenu;
}(_react.Component), _SettingsMenu.defaultProps = {
  plantName: "",
  supportedLocales: {},
  auth: undefined,
  legacy: undefined,
  history: undefined,
  env: undefined
}, _SettingsMenu)) || _class) || _class) || _class) || _class) || _class); //